

























































































































































import '@/assets/scss/pages/app-todo.scss';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import PolicyForm from '@/forms/PolicyForm.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import { FileApi } from '@/services/FileApi';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import {
  DamageStatus,
  IDamage,
  IFile,
  IPolicy,
  ITask,
  PolicyStatus,
  TaskStatus,
} from 'admiral-core';
import { BModal } from 'bootstrap-vue';
import { mixins } from 'vue-class-component';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  InfoIcon,
  ListIcon,
  PlusIcon,
  XIcon,
} from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TaskApi } from '@/services/TaskApi';
import { PolicyApi } from '@/services/PolicyApi';
import { DamageApi } from '@/services/DamageApi';
import PoliciesOverview from '../policies/PoliciesOverview.vue';
import { Util } from '@/utils/Util';
import dayjs from 'dayjs';
import TasksTableOverview from '../tasks/TasksTableOverview.vue';
import DamageOverview from '../damages/DamageOverview.vue';

@Component({
  components: {
    PolicyTimeline,
    FormSubmit,
    PolicyForm,
    Multiselect,
    UserSelect,

    PolicyStatusSelect,
    InfoIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ListIcon,
    ArrowDownIcon,
    PlusIcon,
    TaskOverview,
    XIcon,
    TagSelect,
    AdmiralCheckbox,
    PoliciesOverview,
    TasksTableOverview,
    DamageOverview,
  },
})
export default class AssignFileModal extends mixins(FormMixin, BaseMixin) {
  @Prop({ required: true, type: Object })
  selectedFile!: IFile;

  listType: 'tasks' | 'policies' | 'damages' = 'tasks';

  tasks: ITask[] = [];
  policies: IPolicy[] = [];
  damages: IDamage[] = [];

  isLoading = false;
  isDone = false;
  isContentHovered = false;

  currentPage = 0;
  itemsPerPage = 10;
  searchQuery = '';

  get paginatedPolicies() {
    return this.policies.slice(
      this.currentPage * this.itemsPerPage,
      this.currentPage * this.itemsPerPage + this.itemsPerPage,
    );
  }

  async mounted() {
    // await this.loadTasks();
  }

  // call loadTasks when modal is opened
  async open() {
    await this.loadTasks();
  }

  @Watch('listType')
  async watchListType() {
    if (this.listType === 'tasks') {
      await this.loadTasks();
    } else if (this.listType === 'policies') {
      await this.loadPolicies();
    } else if (this.listType === 'damages') {
      await this.loadDamages();
    }
  }

  @Watch('searchQuery')
  watchSearchQuery() {
    if (this.searchQuery.length === 0 || this.searchQuery.length === 1) {
      this.currentPage = 0;
    }
  }

  policiesPagesCount() {
    return Math.ceil(this.filteredPolicies().length / this.itemsPerPage);
  }
  policiesPaginationCount() {
    return Math.ceil(this.filteredPolicies().length / this.itemsPerPage);
  }

  filteredPolicies(): IPolicy[] {
    const result: IPolicy[] = this.policies;

    if (this.searchQuery.length > 2) {
      return result.filter((policy: IPolicy) =>
        JSON.stringify(policy).toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
    }
    return result;
  }

  async loadTasks() {
    try {
      this.isLoading = true;
      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const response = await TaskApi.getTasks({
        status: [TaskStatus.COMPLETED, TaskStatus.TODO],
        agency: this.user.agency,
        showDemo,
      });
      this.tasks = response.data;
    } catch (e) {
      this.$toastr.e('Beim Laden der Aufgaben ist etwas schief gelaufen.');
    } finally {
      this.isLoading = false;
    }
  }

  async loadPolicies() {
    try {
      this.isLoading = true;
      const policies = await PolicyApi.getPolicies({
        agency: this.user.agency,
        status: [
          PolicyStatus.OPEN,
          PolicyStatus.PLANNED,
          PolicyStatus.DECLINED,
          PolicyStatus.POLICED,
          PolicyStatus.CANCELED,
          PolicyStatus.SUBMITTED,
        ],
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });
      this.policies = policies.data;
    } catch (e) {
      this.$toastr.e('Beim Laden der Anbahnungen ist etwas schief gelaufen.');
    } finally {
      this.isLoading = false;
    }
  }

  async loadDamages() {
    try {
      this.isLoading = true;
      const damages = await DamageApi.getDamages({
        agency: this.user.agency,
        status: [
          DamageStatus.NEW,
          DamageStatus.IN_PROGRESS,
          DamageStatus.PENDING,
          DamageStatus.SUBMITTED,
          DamageStatus.COMPLETED,
          DamageStatus.DECLINED,
        ],
      });
      this.damages = damages.data;
    } catch (e) {
      this.$toastr.e('Beim Laden der Schäden ist etwas schief gelaufen.');
    } finally {
      this.isLoading = false;
    }
  }

  async destroyed() {
    this.$root.$off('bv::modal::hide');
  }

  async ok(evt: Event, close = false) {
    evt.preventDefault();
  }

  async cancel() {
    (this.$refs['assign-file'] as BModal).hide();
  }

  formatOnlyDate(date: Date) {
    return Util.formatDate2(date);
  }

  formatDate(date: Date) {
    return Util.formatDate(date);
  }

  formatDateFull(date: Date) {
    return dayjs(date).format('DD.MM.YYYY HH:mm');
  }

  async selectPolicy(policy: IPolicy) {
    try {
      await FileApi.assignToPolicy(this.selectedFile.id!, policy.id!);
      this.$toastr.s('Datei erfolgreich zugewiesen.');
      this.$emit('reload');
      this.cancel();
    } catch (e) {
      this.$toastr.e('Beim Auswählen der Anbahnung ist etwas schief gelaufen.');
      throw e;
    }
  }

  async selectTask(task: ITask) {
    try {
      await FileApi.assignToTask(this.selectedFile.id!, task.id!);
      this.$toastr.s('Datei erfolgreich zugewiesen.');
      this.$emit('reload');
      this.cancel();
    } catch (e) {
      this.$toastr.e('Beim Auswählen der Aufgabe ist etwas schief gelaufen.');
      throw e;
    }
  }

  async selectDamageById(damageId: string) {
    const damage = this.damages.find((d) => d.id === damageId);
    if (damage) {
      await this.selectDamage(damage);
    }
  }

  async selectDamage(damage: IDamage) {
    try {
      await FileApi.assignToDamage(this.selectedFile.id!, damage.id!);
      this.$toastr.s('Datei erfolgreich zugewiesen.');
      this.$emit('reload');
      this.cancel();
    } catch (e) {
      this.$toastr.e('Beim Auswählen des Schadens ist etwas schief gelaufen.');
      throw e;
    }
  }

  async confirmDeletion() {
    try {
      // await FileApi.delete(this.selectedFile.id!);

      (this.$refs['assign-file'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(`Datei erfolgreich gelöscht.`, 'Datei gelöscht');
    } catch (e) {
      this.$toastr.e('Beim Löschen der Datei ist etwas schief gelaufen.');
      throw e;
    }
  }
}
